jQuery(function() {
    $('.social-block-on-pages').click(function() {
        var classActive = $('.social-block-on-pages_hidden').hasClass('active');
        if(classActive == true){
            $('.social-block-on-pages_hidden').removeClass('active');
        }else{
            $('.social-block-on-pages_hidden').addClass('active');
        }
    });
});


// WEBPACK FOOTER //
// ./blocks/social-in-pages.js